var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-view',{class:_vm.scroll_class,attrs:{"styles":_vm.styles,"state":{
            scroll_x: {
                style: [{ overflowX: 'auto' }],
                state: _vm.scroll === 'x'
            },
            scroll_y: {
                style: [{ overflowY: 'auto' }],
                state: _vm.scroll === 'y'
            },
            scroll_hide: {
                style: [{ overflow: 'hidden' }],
                state: _vm.scroll === 'hide'
            }
        }}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57fbbf33","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/core/b-list.vue
// module id = null
// module chunks = 